module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAQUlEQVQ4y2P4jwQ+MAww7wADDNgPAh7z/0HD4/8DZgwaHgNUaDDw7P8PDh44tvj//x8kPGCGYh4svMGSpwdPWQcA139+F8WQUkEAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6Mjc6MDgrMDk6MDAQgurLAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00982_100x100.png
// module id = yUFC
// module chunks = 0